var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInstagramBlue = function SvgInstagramBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.484)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.759,
    cy: 25.759,
    r: 25.759,
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M30.994 13.295H20.358a7.147 7.147 0 0 0-7.146 7.146v10.553a7.23 7.23 0 0 0 7.146 7.23h10.636a7.23 7.23 0 0 0 7.146-7.23V20.441a7.143 7.143 0 0 0-7.146-7.146zm4.57 17.7a4.654 4.654 0 0 1-4.57 4.653H20.358a4.655 4.655 0 0 1-4.57-4.654V20.441a4.653 4.653 0 0 1 4.57-4.653h10.636a4.652 4.652 0 0 1 4.57 4.653v10.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M25.676 19.943a5.816 5.816 0 1 0 0 11.632 5.816 5.816 0 0 0 0-11.632zm0 8.89a3.157 3.157 0 1 1 0-6.315 3.157 3.157 0 0 1 0 6.316zm6.482-11.383a1.743 1.743 0 0 0-1.202 3.008 1.746 1.746 0 1 0 1.202-3.008z"
  }))));
};

export default SvgInstagramBlue;